export default {
  isActionSheetShow: false,
  // 当前弹框的组件名
  viewName: '',
  viewNameList: [],
  actionParams: {},
  // 弹框的title
  actionHeader: {
    title: '',
    needArrow: false,
    show: true
  },
  // 评论的图片预览
  previewImages: [],
  needArrow: false,
  // 定位地址
  locationInfo: {},
  isMinProgram: false, // 真实是否在小程序中
  inMinProgram: true, // 默认认为是在小程序中，仅用来判断显示隐藏
  choosedCity: {} // 所有城市，根据字母过滤选择城市，全局公用
}
